import { render, staticRenderFns } from "./alarms-expand-panel.vue?vue&type=template&id=2bba7ba6&scoped=true&"
import script from "./alarms-expand-panel.vue?vue&type=script&lang=js&"
export * from "./alarms-expand-panel.vue?vue&type=script&lang=js&"
import style0 from "./alarms-expand-panel.vue?vue&type=style&index=0&id=2bba7ba6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bba7ba6",
  null
  
)

export default component.exports